module.exports = __webpack_public_path__ + "media/images/new_landing/logos/yves-eb0d6f51e1be54c970fb226c18083c28.png";